export type FlagTypes = 'FlagOrcamento'

export const FlagTypes: FlagTypes[] = ['FlagOrcamento']